import { Action } from '@ngrx/store';
import { errorActions } from '@content-platform/web-angular-shared-util-error-handling';
import {
  EmailResource,
  ExternalInvitationEmail,
  RequestNewUserEmail,
} from '../models/email.model.common';

export const SEND_EMAIL_SUCCESS = '[Platform] Send Email Success';
export const SEND_EMAIL_FAILED = '[Platform] Send Email Failed';
export const SEND_INVITATION_EMAIL = '[Platform] Send External Invitation Email';
export const SEND_REQUEST_NEW_USER_EMAIL = '[Platform] Send Request New User Email';
export const SEND_EMAIL = '[Platform] Send Email';

export class SendInvitationEmail implements Action {
  readonly type = SEND_INVITATION_EMAIL;
  constructor(public payload: { invitationEmail: ExternalInvitationEmail }) {}
}

export class SendEmail implements Action {
  readonly type = SEND_EMAIL;
  constructor(public payload: EmailResource) {}
}

export class SendRequestNewUserEmail implements Action {
  readonly type = SEND_REQUEST_NEW_USER_EMAIL;
  constructor(public payload: { requestNewUserEmail: RequestNewUserEmail }) {}
}

export class SendEmailSuccess implements Action {
  readonly type = SEND_EMAIL_SUCCESS;
  constructor(public payload = null) {}
}

export class SendEmailFailed extends errorActions.Fail {
  readonly type = SEND_EMAIL_FAILED;
}

export type All = SendInvitationEmail | SendEmailSuccess | SendEmailFailed | SendEmail;
